import ActiveKlassesSection from '@/components/dashboard/teacher/ActiveKlassesSection';
import YourLessons from '@/components/scheduled-lesson/YourLessons';
import ModernLayout from '@/components/shared/ModernLayout';
import useAuth from '@/data/hook/useAuth';
import { FolderIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { TeacherPendenciesSection } from './teacher/pendencies/TeacherPendenciesSection';
import { TeacherResume } from './teacher/DashboardResume/TeacherResume';

export default function TeacherDashboardView() {
  const { user } = useAuth();
  const { t } = useTranslation('translation', {
    keyPrefix: 'breadcrumb',
  });

  const breadcrumb = [
    { children: t('home'), icon: <FolderIcon className="size-4" /> },
  ];

  if (!user) return null;

  return (
    <ModernLayout items={breadcrumb} classNames={{ div: 'overflow-visible ' }}>
      <div className="flex flex-col gap-6 h-full min-w-0 bg-base-100 p-6 rounded-2xl">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 lg:h-100">
          <TeacherResume user={user} />
          <YourLessons user={user} />
        </div>
        <ActiveKlassesSection />
        <TeacherPendenciesSection user={user} />
      </div>
    </ModernLayout>
  );
}
